import clsx from 'clsx';
import { useEffect } from 'react';
import { useDelayedState } from 'src/utils/useDelayedState';
import { Divider } from './Divider';

export function SidebarDivider({
  expanded,
  className,
  transitionDelay = 100,
}: {
  expanded: boolean;
  className?: string;
  transitionDelay?: number;
}) {
  const [isHidden, setIsHidden] = useDelayedState(!expanded);

  useEffect(() => {
    if (expanded) {
      setIsHidden(false);
    } else {
      setIsHidden(true, transitionDelay); // Delay hiding the element until after the collapse animation
    }
  }, [expanded, setIsHidden]);

  return (
    <div
      className={clsx(
        'px-16',
        {
          'opacity-0': !expanded,
          'opacity-100': expanded,
          hidden: isHidden,
        },
        className
      )}
    >
      <Divider className="my-8" />
    </div>
  );
}
